
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    token: null,
    status: '',
    isloading: false,
    data:{},
    error:{},
    SignInResponse: {},
    OTPResponse:{},
    ResetPasswordResponse:{},
    deliveryResponse:{},
    acceptResponse:{},
    UpdateTokenResponse:{},
    detailsResponse:{},
    UpdateprofileResponse:{},
    ResendotpResponse:{}
}

const FetchDataReducer = createSlice({
    name: 'FetchDataReducer',
    initialState,
    reducers: { 

       //Token
    
    getTokenSuccess(state, action) {
      state.token = action.payload;
      state.status = action.type;
    },
    getTokenFailure(state, action) {
      state.error = action.error;
      state.status = action.type;
    },

      //login
      SignInRequest(state, action) {
        state.status = action.type;
        state.isloading = true;
      },
      SignInSuccess(state, action) {
        state.SignInResponse = action.payload;
        state.status = action.type;
        state.isloading = false;
      },
      SignInFailure(state, action) {
        state.error = action.payload;
        state.status = action.type;
        state.isloading = false;
      },

    

      //otp
      OTPRequest(state, action) {
        state.status = action.type;
        state.isloading = true;
      },
      OTPSuccess(state, action) {
        state.OTPResponse = action.payload;
        state.status = action.type;
        state.isloading = false;
      },
      OTPFailure(state, action) {
        state.error = action.payload;
        state.status = action.type;
        state.isloading = false;
      },

      //resetpassword
      ResetPasswordRequest(state, action) {
        state.status = action.type;
        state.isloading = true;
      },
      ResetPasswordSuccess(state, action) {
        state.ResetPasswordResponse = action.payload;
        state.status = action.type;
        state.isloading = false;
      },
      ResetPasswordFailure(state, action) {
        state.error = action.payload;
        state.status = action.type;
        state.isloading = false;
      },

        //getProfile
        GetProfileRequest(state, action) {
          state.status = action.type;
          state.isloading = true;
        },
        GetProfileSuccess(state, action) {
          state.profileResponse = action.payload;
          state.status = action.type;
          state.isloading = false;
        },
        GetProfileFailure(state, action) {
          state.error = action.payload;
          state.status = action.type;
          state.isloading = false;
        },

       //deliverylist
       DeliveryListRequest(state, action) {
        state.status = action.type;
        state.isloading = true;
      },
      DeliveryListSuccess(state, action) {
        state.deliveryResponse = action.payload;
        state.status = action.type;
        state.isloading = false;
      },
      DeliveryListFailure(state, action) {
        state.error = action.payload;
        state.status = action.type;
        state.isloading = false;
      },

      //Accept/Reject
      AcceptRejectRequest(state, action) {
        state.status = action.type;
        state.isloading = true;
      },
      AcceptRejectSuccess(state, action) {
        state.acceptResponse = action.payload;
        state.status = action.type;
        state.isloading = false;
      },
      AcceptRejectFailure(state, action) {
        state.error = action.payload;
        state.status = action.type;
        state.isloading = false;
      },

       //Details order
        DeliveryDetailsRequest(state, action) {
        state.status = action.type;
        state.isloading = true;
      },
      detailsdataSuccess(state, action) {
        state.detailsResponse = action.payload;
        state.status = action.type;
        state.isloading = false;
      },
      detailsdataFailure(state, action) {
        state.error = action.payload;
        state.status = action.type;
        state.isloading = false;
      },


        //Status Change
        StatusChangeRequest(state, action) {
          state.status = action.type;
          state.isloading = true;
        },
        StatusChangeSuccess(state, action) {
          state.statusResponse = action.payload;
          state.status = action.type;
          state.isloading = false;
        },
        StatusChangeFailure(state, action) {
          state.error = action.payload;
          state.status = action.type;
          state.isloading = false;
        },

         //resend otp
         ResendotpRequest(state, action) {
          state.status = action.type;
          state.isloading = true;
        },
        ResendotpSuccess(state, action) {
          state.ResendotpResponse = action.payload;
          state.status = action.type;
          state.isloading = false;
        },
        ResendotpFailure(state, action) {
          state.error = action.payload;
          state.status = action.type;
          state.isloading = false;
        },

        //Update Profile
        UpdateProfileRequest(state, action) {
          state.status = action.type;
          state.isloading = true;
        },
        UpdateProfileSuccess(state, action) {
          state.UpdateprofileResponse = action.payload;
          state.status = action.type;
          state.isloading = false;
        },
        UpdateProfileFailure(state, action) {
          state.error = action.payload;
          state.status = action.type;
          state.isloading = false;
        },

        //Get bank details
        GetBankRequest(state, action) {
          state.status = action.type;
          state.isloading = true;
        },
        GetBankSuccess(state, action) {
          state.GetBankResponse = action.payload;
          state.status = action.type;
          state.isloading = false;
        },
        GetBankFailure(state, action) {
          state.error = action.payload;
          state.status = action.type;
          state.isloading = false;
        },

         //Get Earning
         GetEarningRequest(state, action) {
          state.status = action.type;
          state.isloading = true;
        },
        GetEarningSuccess(state, action) {
          state.GetEarningResponse = action.payload;
          state.status = action.type;
          state.isloading = false;
        },
        GetEarningFailure(state, action) {
          state.error = action.payload;
          state.status = action.type;
          state.isloading = false;
        },

         //Update Bank
         UpdateBankRequest(state, action) {
          state.status = action.type;
          state.isloading = true;
        },
        UpdateBankSuccess(state, action) {
          state.UpdateBankResponse = action.payload;
          state.status = action.type;
          state.isloading = false;
        },
        UpdateBankFailure(state, action) {
          state.error = action.payload;
          state.status = action.type;
          state.isloading = false;
        },

    },
  });

  export const {
    SignInRequest,
    SignInSuccess,
    SignInFailure,

    getTokenSuccess,
    getTokenFailure,

    OTPRequest,
    ResetPasswordSuccess,
    OTPFailure,

    ResetPasswordRequest,
    OTPSuccess,
    ResetPasswordFailure,

    GetProfileRequest,
    GetProfileSuccess,
    GetProfileFailure,

    DeliveryListRequest,
    DeliveryListSuccess,
    DeliveryListFailure,

    AcceptRejectRequest,
    AcceptRejectSuccess,
    AcceptRejectFailure,

    DeliveryDetailsRequest,
    detailsdataSuccess,
    detailsdataFailure,

    StatusChangeRequest,
    StatusChangeSuccess,
    StatusChangeFailure,

    UpdateProfileRequest,
    UpdateProfileSuccess,
    UpdateProfileFailure,

    ResendotpRequest,
    ResendotpSuccess,
    ResendotpFailure,

    GetBankRequest,
    GetBankSuccess,
    GetBankFailure,

    GetEarningRequest,
    GetEarningSuccess,
    GetEarningFailure,

    UpdateBankRequest,
    UpdateBankSuccess,
    UpdateBankFailure

  
  } = FetchDataReducer.actions;


  export default FetchDataReducer.reducer;

// const FetchDataReducer = (state=initialState, action)=>{
//     switch(action.type){
//         case type.SEND_REQUEST:
//             return{
//                 ...state,
//                 loading: true,
//                 status: true
//             }
//         case type.SEND_REQUEST_SUCCESS:
//             return  {
//                 ...state,
//                 loading:false,
//                 data:action.payload,
//                 error:{},
//                 status: false,

//             }

//         case type.SEND_REQUEST_FAILURE:
//             return{
//                 ...state,
//                 loading:false,
//                 data:action.payload,
//                 error:action.error,
//                 status: false
//             }
//         default:
//             return{
//             ...state
//             }
//     }
// }

// export default FetchDataReducer